import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["slot"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_emh_footnote_reference = _resolveComponent("emh-footnote-reference")!

  return (_openBlock(), _createElementBlock("div", {
    slot: _ctx.slotName,
    class: "emh-stage-campaign-item__additional-data"
  }, [
    _createTextVNode(_toDisplayString(_ctx.product.name) + ", " + _toDisplayString(_ctx.engineDescription) + ", " + _toDisplayString(_ctx.fuelType) + " ", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emissionData, (emission, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createTextVNode(_toDisplayString(emission.label[_ctx.language]) + " ", 1),
        (_ctx.emissionFootnotes)
          ? (_openBlock(), _createBlock(_component_emh_footnote_reference, {
              key: 0,
              "^text": _ctx.emissionFootnotes,
              "^reference": _ctx.generateReference('emission', i)
            }, null, 8, ["^text", "^reference"]))
          : _createCommentVNode("", true),
        _createTextVNode(" : " + _toDisplayString(emission.displayValue), 1)
      ]))
    }), 128))
  ], 8, _hoisted_1))
}